const apiConfig = {
  IdentityURL: process.env.REACT_APP_IDENTITY_API_URL,
  HRserviceURL: process.env.REACT_APP_HR_API_URL,
  AttendanceserviceURL: process.env.REACT_APP_ATTENDANCE_API_URL,
  RecruitmentserviceURL: process.env.REACT_APP_RECRUITMENT_API_URL,
  PayrollserviceURL: process.env.REACT_APP_PAYROLL_API_URL,
  HelpdeskserviceURL: process.env.REACT_APP_HELPDESK_API_URL,
};

export default apiConfig;